'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CONFIG_QUERY = 'config:query';
var WALLET_CONFIG_QUERY = 'config:wallet:query';

exports.CONFIG_QUERY = CONFIG_QUERY;
exports.WALLET_CONFIG_QUERY = WALLET_CONFIG_QUERY;
